import moment from 'moment/moment'
import { type CamelCasedPropertiesDeep } from 'type-fest'

import {
  type CompanyEntitlementResponse,
  type EntitlementsFlat
} from 'types/api/companies/entitlements'
import { keysToCamelCase } from 'utils/obj'

/**
 * @returns the numeric difference between dateEnd and today in days
 */
export function getDaysUntilEntitlementExpiration(
  dateEnd: string | Date,
  today?: moment.Moment | Date
) {
  const momentToday = moment.isMoment(today) ? today : moment(today)
  const momentEndDate = moment(dateEnd)
  return momentEndDate.diff(momentToday, 'days')
}

export function getEntitlementsExpirationProperties(dateEnd: string | Date) {
  const daysUntilContractExpiration = getDaysUntilEntitlementExpiration(dateEnd)

  return {
    contractExpirationImminent: daysUntilContractExpiration <= 7,
    daysUntilContractExpiration
  }
}

export function flattenEntitlements(
  entitlementsResponse: CompanyEntitlementResponse
): EntitlementsFlat {
  // todo: EN-6511 fix types
  const {
    limits,
    ...entitlements
  }: CamelCasedPropertiesDeep<CompanyEntitlementResponse> =
    keysToCamelCase(entitlementsResponse)

  // todo: EN-6511 fix types, remove `as number` after entitlements migration
  const limitsMapped = {
    limitAgents: limits.limitAgents ?? (limits.agents as number),
    limitServices: limits.limitServices ?? (limits.services as number),
    limitTargets: limits.limitTargets ?? (limits.targets as number),
    limitTeams: limits.limitTeams ?? (limits.teams as number),
    limitUsers: limits.limitUsers ?? (limits.users as number)
  }

  return {
    companyId: entitlements.companyId,
    dateStart: entitlements.createdAt,
    dateEnd: entitlements.end,
    dateUpdated: entitlements.updatedAt,
    isInternal: entitlements.internal,
    isStrict: entitlements.strict,
    hasAgentBilling: entitlements.hasAgentBilling,
    hasTrialBanners: entitlements.hasTrialBanners,
    hasProductFI: entitlements.productFlags.hasProductFI,
    hasProductRM: entitlements.productFlags.hasProductRM,
    hasProductFF: entitlements.productFlags.hasProductFF,
    targetsTrackingPeriod: entitlements.targetsTrackingPeriod,
    ...limitsMapped
  }
}
